import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.MODULE_USERMEDIS_SET_LOADER,
        payload: data
    }
};

export const getMasterData =  () => {
    return ({
        type: types.MODULE_USERMEDIS_MASTER_DATA,
    })
}

export const handleStateForm =  (property, value) => {
    return ({
        type: types.MODULE_USERMEDIS_HANDLE_STATE_FORM,
        property,
        value
    })
}

export const postFormUserMedis = (history, value) => {
    return ({
        type: types.MODULE_USERMEDIS_SUBMIT_FORM_USERMEDIS,
        history,
        value
    })
}

export const getDataUserMedis =  (value) => {
    return ({
        type: types.MODULE_USERMEDIS_LISTDATA_USERMEDIS,
        value
    })
}